module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/svgs/pattern_right-132eed8dec358e9007c7253ee76553cb.svg";